export default __webpack_public_path__ + "static/LeituraSansTwo-Bold-6998c3d4ba435e1c513642e31ce61531.woff";